/**
 * 🌐 PROVIDER-SPECIFIC DATA CLIENT
 *
 * Type-safe provider operations (Spaceship, Namecheap, Name.com) following Convex best practices.
 */
import { api } from "@convex/_generated/api";
import { BaseDataClient } from "./baseClient";
/**
 * Provider-specific operations client
 */
export class ProvidersClient extends BaseDataClient {
    // ========================================
    // 🚀 SPACESHIP OPERATIONS
    // ========================================
    async setSpaceshipAutoSync(params) {
        return await this.client.mutation(api.spaceship.setSpaceshipAutoSync, params);
    }
    async deleteSpaceshipConnection(params) {
        return await this.client.mutation(api.spaceship.deleteSpaceshipConnection, params);
    }
    async saveSpaceshipCredentials(params) {
        return await this.client.mutation(api.spaceship.saveSpaceshipCredentials, params);
    }
    // ========================================
    // 🌐 NAME.COM OPERATIONS
    // ========================================
    async setNamecomAutoSync(params) {
        return await this.client.mutation(api.namecom.setNamecomAutoSync, params);
    }
    async deleteNamecomConnection(params) {
        return await this.client.mutation(api.namecom.deleteNamecomConnection, params);
    }
    async saveNamecomCredentials(params) {
        return await this.client.mutation(api.namecom.saveNamecomCredentials, params);
    }
    // ========================================
    // 🏪 NAMECHEAP OPERATIONS
    // ========================================
    async setNamecheapAutoSync(params) {
        return await this.client.mutation(api.namecheap.setNamecheapAutoSync, params);
    }
    async deleteNamecheapConnection(params) {
        return await this.client.mutation(api.namecheap.deleteNamecheapConnection, params);
    }
    async saveNamecheapCredentials(params) {
        return await this.client.mutation(api.namecheap.saveNamecheapCredentials, params);
    }
    // ========================================
    // 🧪 EPHEMERAL TEST OPERATIONS (WEB ONLY)
    // ========================================
    async testNamecomCredentialsEphemeral(params) {
        const res = await this.client.action(api.namecom.testNamecomCredentialsEphemeral, params);
        return res;
    }
    async testSpaceshipCredentialsEphemeral(params) {
        const res = await this.client.action(api.spaceship.testSpaceshipCredentialsEphemeral, params);
        return res;
    }
    async testNamecheapCredentialsEphemeral(params) {
        const res = await this.client.action(api.namecheap.testNamecheapCredentialsEphemeral, params);
        return res;
    }
}
/**
 * Factory function to create a ProvidersClient
 */
export function createProvidersClient(client) {
    return new ProvidersClient(client);
}
